import { makeStyles } from '@material-ui/styles'
import { useAppSelector } from 'app/store'
import { ArrayElement } from 'core/actions/Action'
import Alert from 'core/components/Alert'
import CustomDeleteDialog from 'core/components/CustomDeleteDialog'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import React, { useMemo } from 'react'
import { virtualMachinesSelector } from '../selectors'
import { deleteServerGroup } from './actions'

const columns = [
  {
    key: 'serverGroup',
    label: 'Server Group',
    render: (group) => (group ? `${group?.name} (${group?.policy})` : ''),
    sortFn: (a, b) => (a?.name || '').localeCompare(b?.name || ''),
  },
  {
    key: 'name',
    label: 'VM Name',
    render: (name) => <Text variant="caption1">{name}</Text>,
  },
]

type SelectorModel = ArrayElement<ReturnType<typeof virtualMachinesSelector>>

// 🔹 Warning message
const WarningMessage = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.container}>
        <Alert
          variant="warning"
          message="Deleting a server group will detach all VMs from it, and the associated affinity or anti-affinity policy will no longer apply to those instances."
        />
      </div>
      <Text variant="subtitle2">Do you still want to delete the following Server Group(s):</Text>
    </>
  )
}

export default function DeleteServerGroupsDialog(props) {
  const { rows: serverGroups } = props
  const classes = useStyles()
  // const { loading: loadingVms } = useListAction(listVirtualMachines, {
  //   loadOnDemand: true,
  //   ignoreDependency: true,
  // })
  const vms = useAppSelector(virtualMachinesSelector)
  const serverGroupNames = useMemo(() => serverGroups?.map((row) => row?.name), [serverGroups])

  // 🔹 VMs affected by delete
  // const filteredVmData = useMemo(
  //   () => vms?.filter((vm) => serverGroupNames?.includes(vm?.serverGroup?.name)),
  //   [vms, serverGroupNames],
  // )

  return (
    <CustomDeleteDialog
      {...props}
      deleteAction={deleteServerGroup}
      maxWidth={800}
      title="Delete Server Group(s)"
      resourceLabel="server group(s)"
      subTitle={<WarningMessage />}
    />
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
}))
